import React, { FC, ReactElement, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import cns from 'classnames';
import {
  isSectionVisible,
  toggleVisibility,
  editSelectedBlock,
  getEditBlock,
  changeBlockName,
} from '../../../../stores/reducers/sections';
import Icon from '../../../Icon';
import styles from './Section.module.scss';
import './section.styles.sass';
import { internalizationState } from '../../../../stores/reducers/sections';
import localeFieldResolver from '../../../../helpers/locale-field-finder';
interface ITitles {
  name: string;
  name_en: string;
}
interface SectionProps {
  title: ITitles
  id: number;
  isOpened?: boolean;
}

const Section: FC<SectionProps> = ({ title, id, isOpened = false, children }): ReactElement => {
  const dispatch = useDispatch();
  const isVisible = useSelector(isSectionVisible(id));
  const editBlock = useSelector(getEditBlock());
  const [newBlock, setNewBlock] = useState<ITitles>(title);
  const [isOpen, setIsOpen] = useState<boolean>(isOpened);
  const { activeLangState, internalization, isAwailableLocaleSwitcher } = useSelector(internalizationState);
  const [activeInputLang, setActiveInputLang] = useState<string>(activeLangState);

  useEffect(() => {
    setActiveInputLang(activeLangState);
  }, [activeLangState]);

  const updateBlockTitle = (value: string, key: string) => {
    setNewBlock((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const titleInput = (): ReactElement => {
    if (internalization && isAwailableLocaleSwitcher) {
      return (
        <>
          <div className="input-lang-switcher">
            <button
              className={cns(
                "input-lang-switcher__button",
                'title-input', activeInputLang === 'ru' && 'active'
              )}
              onClick={(e) => {
                e.stopPropagation();
                setActiveInputLang('ru');
              }}
            >
              ru
            </button>
            <button
              className={cns(
                "input-lang-switcher__button",
                'title-input', activeInputLang === 'en' && 'active'
              )}
              onClick={(e) => {
                e.stopPropagation();
                setActiveInputLang('en');
              }}
            >
              en
            </button>
          </div>
          <input className={cns('title-input-lang', activeInputLang === 'en' && 'active')} type="text" onChange={(e) => updateBlockTitle(e.target.value, 'name_en')} defaultValue={title.name_en} />
          <input className={cns('title-input-lang', activeInputLang === 'ru' && 'active')} type="text" onChange={(e) => updateBlockTitle(e.target.value, 'name')} defaultValue={title.name} />
        </>
      );
    }

    if (internalization && activeLangState === 'en' && !isAwailableLocaleSwitcher) {
      return (<input type="text" onChange={(e) => updateBlockTitle(e.target.value, 'name_en')} defaultValue={title.name_en} />);
    }
    
    return (<input type="text" onChange={(e) => updateBlockTitle(e.target.value, 'name')} defaultValue={title.name} />);
  };

  return (
    <li className={cns(styles.block, isOpen && 'opened', isOpen && styles._opened)}>
      <div className="setting-drop-list__tt" role="button" tabIndex={0} onClick={() => setIsOpen(!isOpen)}>
        {editBlock === id ? (
          titleInput()
          // <>
          //   <input type="text" onChange={(e) => setNewBlock(e.target.value)} defaultValue={title.name} />
          // </>
        ) : (
          localeFieldResolver(title, 'name', activeLangState)
        )}
        <button
          type="button"
          className="setting-field-btn"
          onClick={(e) => {
            e.stopPropagation();
            dispatch(toggleVisibility(id));
          }}>
          <Icon name={isVisible ? 'eye' : 'blind-eye'} />
        </button>
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            dispatch(editBlock === id ? changeBlockName({ id, title: {...newBlock} }) : editSelectedBlock(id));
          }}>
          {editBlock === id ? 'Save' : 'Edit'}
        </button>
      </div>
      <div className={cns('setting-drop-list__inner', styles.inner)}>{children}</div>
    </li>
  );
};

export default Section;
